import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  sbFooterContainer: {
    [theme.breakpoints.down("sm")]: {
      minHeight: "150px",
      height: "150px"
    }
  },
  headerLink: {
    textDecoration: "none",
    color: theme?.palette?.primaryText?.[100],
    textTransform: "uppercase",
    padding: "5px 20px",
    fontWeight: "500",
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap"
    }
  },
  activeLink: {
    color: `${theme?.palette?.primary2TextColor?.main} !important`
  },
  footerLogo: {
    textAlign: "center",
    padding: "20px 0 8px",
    "& img,svg": {
      width: "100px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 0 20px"
    }
  },
  footerSection: {
    //  position: "fixed",
  //   position: "fixed",
  // bottom: 0,
  // left: 0,
  //  width: "100%",
  // zIndex: 1000,
    marginTop: "1px",
    marginLeft: "12%",
    marginRight: "12%",

    // For 1024px and below
    [theme.breakpoints.down(1030)]: {
      marginLeft: "7%",
      marginRight: "7%"
    },

    // Optional: Mobile (below 600px)
    [theme.breakpoints.down("sm")]: {
      marginLeft: "3%",
      marginRight: "3%"
    }
  },
  footerWrap: {
    // background: theme?.palette?.primaryBG?.[500],
    padding: "20px 70px 10px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    "& a , & button": {
      display: "block",
      padding: "5px 0",
      fontSize: "12px",
      textAlign: "center",
      margin: "auto",
      textDecoration: "none",
      textTransform: "capitalize",

      "&:hover": {
        background: "transparent"
      }
    },
    "& .carousel-root": {
      borderBottom: "1px solid rgb(0 0 0 / 22%)",
      height: "auto",
      paddingBottom: "15px",
      maxWidth: "calc(100% - 30rem)",
      margin: "0 auto",
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%"
      },
      "& .carousel-slider": {
        overflow: "visible",
        "& .control-next.control-arrow": {
          right: "0px",
          zIndex: "1"
        },
        "& .control-prev.control-arrow": {
          left: "0px",
          zIndex: "1"
        },
        "& .control-dots": {
          bottom: "-8px",
          [theme.breakpoints.up("sm")]: {
            bottom: "-18px"
          }
        }
      }
    },
    "& h6": {
      fontSize: "16px",
      fontWeight: "600"
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      padding: "10px 10px 10px"
    }
  },
  footerLinkingWrap: {
    padding: "0 0 10px",
    maxWidth: "70%",
    margin: "0 auto",
    borderBottom: "1px solid rgb(0 0 0 / 22%)",
    [theme.breakpoints.down("lg")]: {
      padding: "10px 15px 6px"
      // maxWidth: "50%",
    },
    [theme.breakpoints.down("md")]: {
      padding: "10px 15px 6px",
      maxWidth: "100%"
    }
  },
  footerCopyrightSection: {
    // background: theme.palette?.primaryBG?.[500],
    padding: "4px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      padding: "10px",
      flexFlow: "column-reverse",
      paddingBottom: "60px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 12px 65px",
      minHeight: "100%"
    }
  },
  footerInstruction: {
    display: "flex",
    justifyContent: "center",
    gap: "40px",
    marginTop: "40px",

    "& img,svg": {
      margin: "0 20px",
      // width: "90px",
      // height: "90px",
      objectFit: "contain",
      [theme.breakpoints.down("sm")]: {
        margin: "0 10px",
        width: "60px",
        height: "60px",
        objectFit: "contain"
      }
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }
  },

  footerInstructionText: {
    textAlign: "center"
  },
  footerLinking: {
    padding: "10px 15px",
    borderTop: " 2px solid rgba(255, 255, 255, 0.6)",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      overflowX: "auto",
      justifyContent: "flex-start",
      padding: "10px 0px",
      whiteSpace: "nowrap",
      borderTop: "none"
    },
    "& a": {
      textDecoration: "none",
      color: theme?.palette?.primaryText?.[100],
      fontSize: "16px",
      padding: "5px 20px",
      [theme.breakpoints.down("md")]: {
        padding: "10px",
        whiteSpace: "nowrap",
        fontSize: "12px",
        display: "block"
      }
    },
    "& .MuiButtonBase-root": {
      "&:hover": {
        background: "transparent"
      }
    }
  },
  footerCopyright: {
    background: theme?.palette?.primaryBG?.[450],
    padding: "0px 40px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      padding: "20px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 15px",
      flexFlow: "column-reverse"
    },
    "& .MuiTypography-body1": {
      // width: "100%",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
        textAlign: "center",
        marginTop: "10px"
      }
    }
  },

  footerCopyrightLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    // [theme.breakpoints.up("md")]: {
    //   marginLeft: "auto",
    // },
    "& img,svg": {
      width: "104px",
      height: "28px",
      objectFit: "contain",
      marginRight: "10px",
      [theme.breakpoints.down("sm")]: {
        margin: "0px 0 5px",
        width: "82px",
        height: "22px",
        objectFit: "contain"
      }
    },
    "& .MuiTypography-root": {
      fontSize: "14px",
      color: theme?.palette?.primaryText?.[250],
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
        lineHeight: "1.35",
        textAlign: "center",
        color: `${theme?.palette?.primaryText?.[100]} !important`,
        opacity: "0.9",
        padding: "0 6px",
        wordBreak: "break-word"
      }
    },
    [theme.breakpoints.down("sm")]: {
      flexFlow: "column",
      rowGap: "6px"
    }
  },

  footerBtn: {
    textDecoration: "none",
    color: theme?.palette?.primaryText?.[100],
    textTransform: "uppercase",
    padding: "5px 20px",
    fontWeight: "500",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      fontSize: "12px",
      padding: "5px 8px",
      minWidth: "auto"
    },
    fontSize: "15px",
    "& .MuiTouchRipple-root": {
      position: "static"
    }
  },
  cmsLoading: {
    margin: "20px",
    color: theme?.palette?.primary2TextColor?.main
  },
  mainContainer: {
    minHeight: "100vh"
  },

  footerPartnerWrap: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 0 20px",
    [theme.breakpoints.up("lg")]: {
      overflowX: "auto"
    }
  },

  footerInstructionLogos: {
    display: "flex",
    justifyContent: "center",
    // margin:"40px",

    "& img,svg": {
      margin: "0 30px",
      width: "110",
      // height: "110px",
      objectFit: "contain"
    }
  },
  logo: {
    width: 120,
    height: 120,
    margin: "10px",
    objectFit: "contain" // ensures proper scaling within the box
  },
  providerimg: {
    borderRadius: "10px 10px 10px 10px"
  },
  sliderwrap: {
    marginTop: "20px",
    marginBottom: "20px",
    "& .slick-slide": {
      display: "flex",
      // width: "178px !important",
      height: "128px",
      paddingRight: "15px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "2px",
      flexShrink: "0",
      "& a": {
        borderRadius: "10px",
        background: theme?.palette?.primaryBG?.[400],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%"
      },
      "& div": {
        width: "100%",
        height: "100%"
      },
      "& img,svg": {
        width: "120px",
        objectFit: "contain"
      }
    }
  },
  providersliderwrap: {
    "& .slick-dots li button": {
      // background:"white",
      color: "white"
    }
    // "& .slick-active":{
    //   background:"white"
    //      }
  },

  "& .slick-dots": {
    "& .slick-active": {
      "& button": {
        "&:before": {
          opacity: "1",
          color: `${theme?.palette?.primaryText?.[100]}`
        }
      }
    }
  },
  staticContainer: {
    padding: "0 15px",
    marginTop: "108px",
    marginBottom: "24px"
  },
  staticThemeCard: {
    background: theme?.palette?.primaryBG?.[350],
    borderRadius: "10px",
    margin: "10px 0",
    padding: "20px",
    minHeight: "500px"
  },
  footerSlider: {
    "& .slick-dots li": {
      "&.slick-active button:before": {
        opacity: 1,
        color: "white"
      },
      "& button:before": {
        opacity: 0.25,
        color: "white"
      }
    }
  }
}));
